import Vue from 'vue'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import {library} from '@fortawesome/fontawesome-svg-core'
import {
    faExternalLink,
    faAddressCard,
    faChartLine,
    faPersonWalkingLuggage,
    faArrowLeft,
    faArrowRightFromBracket,
    faArrowUpRightFromSquare,
    faBars,
    faChevronDown,
    faChevronLeft,
    faFilePdf,
    faChevronRight,
    faChevronUp,
    faCircleCheck as faCircleCheckSolid,
    faCircleExclamation,
    faCommentDots,
    faComments,
    faCopy,
    faEllipsis,
    faEllipsisVertical,
    faFileCircleCheck,
    faFileInvoiceDollar,
    faHome,
    faListCheck,
    faLocationDot,
    faLocationPin,
    faPencil,
    faPenToSquare,
    faPhone,
    faPlus,
    faRightToBracket,
    faSearch,
    faTrash,
    faPrint,
    faTrashCan,
    faUsers,
    faCalendar,
    faEnvelope,
    faBoxesStacked,
    faRobot,
    faUser,
    faLock,
    faTable,
    faFileDownload,
    faBell,
    faCircleXmark,
    faChartSimple,
    faArrowTrendUp,
    faClock,
    faPhoneVolume,
    faClipboardCheck,
    faHandHoldingDollar,
    faArrowsRotate,
    faArrowCircleRight,
    faEye,
    faBoxOpen,
    faTaxi,
    faBus,
    faBuilding,
    faHelmetSafety,
    faHourglass,
    faHeadset,
    faMoneyBill1Wave,
    faMoneyBill,
    faReceipt,
    faMoneyBills,
    faIdBadge,
    faWifi,
    faCameraRetro, faCirclePlus, faPaperPlane, faPersonWalkingArrowRight, faStore, faQrcode, faInfo, faInfoCircle,  faToggleOn, faToggleOff, faUserPlus

} from '@fortawesome/free-solid-svg-icons'
import {faCircleCheck, faCommentDots as faCommentDotsR} from '@fortawesome/free-regular-svg-icons'

Vue.component('font-awesome-icon', FontAwesomeIcon)
library.add(faEllipsisVertical, faEllipsis, faPlus, faArrowLeft, faHome, faBars, faInfo, faChevronLeft, faCopy,faEnvelope,faRobot,faUser,faTable,faChartSimple,
    faChevronRight, faCircleExclamation, faPencil, faTrash, faUsers, faLocationPin, faAddressCard, faLocationDot, faPenToSquare,faLock,faMoneyBills,faExternalLink,
    faTrashCan, faRightToBracket, faCommentDots, faArrowRightFromBracket, faCircleCheckSolid, faCircleCheck, faChevronUp,faBoxesStacked,faFileDownload,faArrowsRotate,faIdBadge,
    faChevronDown, faListCheck, faComments, faPrint,faCommentDotsR, faFileInvoiceDollar, faFileCircleCheck, faArrowUpRightFromSquare, faSearch,faCircleXmark,faHandHoldingDollar,faArrowCircleRight,
    faPhone, faCalendar, faBell, faArrowTrendUp, faClock,  faPhoneVolume, faClipboardCheck,faEye,faBoxOpen,faTaxi,faBus,faBuilding,faHelmetSafety,faHourglass,faHeadset,faMoneyBill1Wave,faMoneyBill,faReceipt,faWifi,
    faChartLine,faCameraRetro, faCirclePlus,faPersonWalkingLuggage,faFilePdf,faPaperPlane,  faToggleOn, faToggleOff, faPencil,faPersonWalkingArrowRight, faStore, faQrcode, faInfoCircle, faUserPlus
)